// ============================================================
//  Apex Predator Boost – apex-predator.js
//  RP Boost + Safe Predator Sections
// ============================================================

(function () {
  'use strict';

  // ── Konfiguration ─────────────────────────────────────────
  const RP_PRICE_PER_1000 = 75; // €

  const PLATFORM_PRICES = {
    xbox: 799,
    ps:   849,
    pc:   949,
  };

  const RP_OPTIONS = [1000, 2000, 3000, 4000, 5000, 10000];

  // Shopify Product Handles — SKU-basiertes Lookup wie beim Ranked Calculator
  const PRODUCT_HANDLES = {
    rp: 'apex-predator-rp-boost',
    sp: 'apex-safe-predator',
  };

  // Variant-Daten werden per API geladen (SKU → Variant ID)
  const variantData = {
    rp: {}, // PRED-RP-1000 → variantId
    sp: {}, // PRED-SAFE-PC → variantId
  };

  // ── State ─────────────────────────────────────────────────
  const state = {
    rp: {
      selected: 2000, // default
    },
    sp: {
      platform: 'pc', // default
      rank: 'D4',     // default
    }
  };

  // ── Init ──────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', async () => {
    if (!document.getElementById('pred-rp-section')) return;
    await loadVariants();
    initRP();
    initSP();
  });

  // ── Varianten laden ────────────────────────────────────────
  async function loadVariants() {
    try {
      const [rpProduct, spProduct] = await Promise.all([
        fetch(`/products/${PRODUCT_HANDLES.rp}.js`).then(r => r.json()),
        fetch(`/products/${PRODUCT_HANDLES.sp}.js`).then(r => r.json()),
      ]);

      rpProduct.variants.forEach(v => {
        if (v.sku) variantData.rp[v.sku] = v.id;
      });
      spProduct.variants.forEach(v => {
        if (v.sku) variantData.sp[v.sku] = v.id;
      });

      console.log('[PredBoost] Varianten geladen ✓', variantData);
    } catch (err) {
      console.error('[PredBoost] Fehler beim Laden der Varianten:', err);
    }
  }

  // ── RP BOOST ──────────────────────────────────────────────
  function initRP() {
    const grid = document.getElementById('pred-rp-grid');
    if (!grid) return;

    RP_OPTIONS.forEach(rp => {
      const btn = document.createElement('button');
      btn.className = `pred-rp-btn${rp === state.rp.selected ? ' active' : ''}`;
      btn.dataset.rp = rp;

      const price = (rp / 1000) * RP_PRICE_PER_1000;
      const popular = rp === 2000;

      btn.innerHTML = `
        ${popular ? '<span class="rp-popular">Beliebt</span>' : ''}
        <span class="rp-amount">${rp >= 1000 ? (rp/1000)+'K' : rp}</span>
        <span class="rp-label">RP</span>
      `;

      btn.addEventListener('click', () => selectRP(rp));
      grid.appendChild(btn);
    });

    updateRPPrice();

    document.getElementById('pred-rp-cta')
      ?.addEventListener('click', handleRPCheckout);
  }

  function selectRP(rp) {
    state.rp.selected = rp;
    document.querySelectorAll('.pred-rp-btn').forEach(b => {
      b.classList.toggle('active', parseInt(b.dataset.rp) === rp);
    });
    updateRPPrice();
  }

  function updateRPPrice() {
    const price = (state.rp.selected / 1000) * RP_PRICE_PER_1000;
    const el = document.getElementById('pred-rp-price');
    if (el) el.textContent = `${price.toFixed(0)} €`;

    const sub = document.getElementById('pred-rp-sub');
    if (sub) sub.textContent = `${state.rp.selected.toLocaleString('de-DE')} Ranked Points`;
  }

  async function handleRPCheckout() {
    const sku = `PRED-RP-${state.rp.selected}`;
    const variantId = variantData.rp[sku];
    if (!variantId) {
      alert('Produkt nicht gefunden – bitte Seite neu laden.');
      return;
    }
    await addToCart(variantId, {
      'RP Menge': `${state.rp.selected} RP`,
    });
  }

  // ── SAFE PREDATOR ─────────────────────────────────────────
  function initSP() {
    // Platform buttons
    document.querySelectorAll('.pred-platform-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const platform = btn.dataset.platform;
        state.sp.platform = platform;
        document.querySelectorAll('.pred-platform-btn').forEach(b =>
          b.classList.toggle('active', b.dataset.platform === platform)
        );
        updateSPPrice();
      });

      // Set default active
      if (btn.dataset.platform === state.sp.platform) {
        btn.classList.add('active');
      }
    });

    // Rank pills
    document.querySelectorAll('.pred-rank-pill').forEach(btn => {
      btn.addEventListener('click', () => {
        const rank = btn.dataset.rank;
        state.sp.rank = rank;
        document.querySelectorAll('.pred-rank-pill').forEach(b =>
          b.classList.toggle('active', b.dataset.rank === rank)
        );
      });

      if (btn.dataset.rank === state.sp.rank) {
        btn.classList.add('active');
      }
    });

    updateSPPrice();

    document.getElementById('pred-sp-cta')
      ?.addEventListener('click', handleSPCheckout);
  }

  function updateSPPrice() {
    const price = PLATFORM_PRICES[state.sp.platform] ?? 949;
    const el = document.getElementById('pred-sp-price');
    if (el) el.textContent = `${price.toFixed(0)} €`;
  }

  async function handleSPCheckout() {
    const sku = `PRED-SAFE-${state.sp.platform.toUpperCase()}`;
    const variantId = variantData.sp[sku];
    if (!variantId) {
      alert('Produkt nicht gefunden – bitte Seite neu laden.');
      return;
    }
    await addToCart(variantId, {
      'Plattform':      state.sp.platform.toUpperCase(),
      'Aktueller Rang': state.sp.rank,
    });
  }

  // ── Cart Helper ───────────────────────────────────────────
  async function addToCart(variantId, properties) {
    const ctaBtns = document.querySelectorAll('.pred-cta');
    ctaBtns.forEach(b => { b.disabled = true; b.textContent = 'Wird hinzugefügt…'; });

    try {
      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1, properties }]
        }),
      });

      if (!res.ok) throw new Error('Cart error');
      window.location.href = '/checkout';

    } catch (err) {
      console.error('[PredBoost] Fehler:', err);
      ctaBtns.forEach(b => {
        b.disabled = false;
        b.textContent = 'Fehler – erneut versuchen';
      });
    }
  }

})();
